import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import WorkListPage from "@/pages/work-list/page";
import NewsPage from "@/pages/news/page";
import ActressDetailPage from "@/pages/detail/actress/page";
import WorkDetailPage from "@/pages/detail/work/page";
import NewsDetailPage from "@/pages/detail/news/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <CategoryPage />,
  },
  {
    path: "/work-list",
    element: <WorkListPage />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/detail/actress/:id",
    element: <ActressDetailPage />,
  },
  {
    path: "/detail/work/:id",
    element: <WorkDetailPage />,
  },
  {
    path: "/detail/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;